import { Heart } from "lucide-react";
import { useFavorites } from "../hooks/useFavorites";

// Reusable "loved it" heart toggle. Filled = favorited. Stops propagation so it
// can sit on clickable cards without opening the title.
export default function FavoriteHeart({ item, size = 14, className = "" }) {
  const { inList, toggle } = useFavorites();
  const id = typeof item === "string" ? item : item.id;
  const faved = inList(id);
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); toggle(item); }}
      data-testid={`favorite-toggle-${id}`}
      aria-pressed={faved}
      title={faved ? "Remove from Favorites" : "Add to Favorites"}
      className={`flex items-center justify-center rounded-[var(--card-radius)] border transition-colors ${faved ? "border-[var(--accent)] bg-[var(--accent)] text-white" : "border-white/60 bg-black/50 text-white hover:bg-black/70"} ${className}`}
    >
      <Heart size={size} className={faved ? "fill-current" : ""} />
    </button>
  );
}
